import { ENUM_PropertyInvestmentType } from '@api-new/common';
import { createSelector } from '@ngrx/store';
import { ClientUserData } from '@platform/smart-search/models/client-user-data.model';
import { selectClientUser } from '@shared/store/client-user/client-user.selectors';
import { selectProperties } from '@shared/store/properties/properties.selectors';
import dayjs from 'dayjs';

export const selectAddSmartSearchDialogClientUserData = createSelector(
  selectClientUser,
  (clientUser): ClientUserData =>
    clientUser && {
      firstName: clientUser.firstName,
      lastName: clientUser.lastName,
      fullName: clientUser.fullName,
      phoneNumber: clientUser.phoneNumber,
      age: dayjs().year() - dayjs(clientUser.dateOfBirth).year(),
      dateOfBirth: clientUser.dateOfBirth,
    },
);

export const selectHasClientResidentialProperty = createSelector(
  selectProperties,
  (properties) =>
    !!properties.find((property) => property.investmentType === ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_RESIDENTIAL),
);
